import React from 'react';

function LastInitial({ dir, root, number, level, onClick }) {
  return (
    <div className="questionContent questionUseDoctor happyDoctor">
      <div className="questionInitial questionLastInitial questionTxt">
        <div className="questionTxtInner">
          ありがとう。キミのおかげでカプセルを見つけることができた。
          <br />
          これで未来にまたみどりをとりもどすことができる。
          <br />
          みどりのない未来にしないために最後の謎ときがあるようじゃ。といてみてくれ。
        </div>
      </div>
      <button
        onTouchStart={() => {}}
        className="questionBtn questionStartBtn questionInitialNextBtn"
        onClick={() => {
          root.dispatchEvent(
            new CustomEvent('start', {
              detail: {
                level: level + 1,
                number: number + 1,
              },
            })
          );
          onClick();
        }}
      >
        <img src={dir + 'assets/img/btn-next-lg.png'} alt="次の謎へ" />
      </button>
    </div>
  );
}

export default LastInitial;
